import routes from '../../routes';
import Dialogs from '../dialogs/a11y-dialog-component';
import isMobileDisplay from '../mobile/check';
import analytics from '../../analytics';
const DIALOG_WISHLIST_DISABLED_ID = 'dialog-wishlist-disabled';
const DIALOG_WISHLIST_ADD_ID = 'dialog-wishlist';
const WISHLIST_ITEMS = window.userData?.wishlistItems ?? [];
const PENDING_EANS = new Set();
let isToggleInitialized = false;
function setState(wishlistComponent, state = 'remove') {
    const toggleButton = wishlistComponent.querySelector('button');
    if (!toggleButton)
        return;
    const ean = wishlistComponent.dataset.wishlistProductEan;
    const labelAdd = wishlistComponent.dataset.labelAdd;
    const labelRemove = wishlistComponent.dataset.labelRemove;
    toggleButton.setAttribute('aria-pressed', state === 'remove' ? 'true' : 'false');
    const ariaLabel = state === 'remove' ? labelRemove : labelAdd;
    if (ariaLabel)
        toggleButton.setAttribute('aria-label', ariaLabel);
    if (!ean)
        return;
    const wishlistItemIndex = WISHLIST_ITEMS.indexOf(ean);
    if (state === 'remove' && wishlistItemIndex === -1) {
        WISHLIST_ITEMS.push(ean);
    }
    if (state === 'add' && wishlistItemIndex !== -1) {
        WISHLIST_ITEMS.splice(wishlistItemIndex, 1);
    }
}
function setStateAll(component, state = 'remove') {
    document
        .querySelectorAll(`*[data-component="wishlist-item"][data-wishlist-product-ean="${component.dataset.wishlistProductEan}"]`)
        .forEach((wishlistComponent) => {
        setState(wishlistComponent, state);
    });
}
function setInitialState(wishlistComponents) {
    wishlistComponents.forEach((wishlistComponent) => {
        if (window.userData && WISHLIST_ITEMS.includes(wishlistComponent.dataset.wishlistProductEan ?? '')) {
            setState(wishlistComponent);
        }
        else {
            setState(wishlistComponent, 'add');
        }
    });
}
function changeEanInEndpoint(endpoint) {
    const selectedInput = document.querySelector(`input[name="ean[${isMobileDisplay() ? 'mobile' : 'desktop'}][]"][type=checkbox]:checked`);
    if (selectedInput) {
        return endpoint.substring(0, endpoint.lastIndexOf('/') + 1) + selectedInput.value;
    }
    return endpoint;
}
function updateProductImage(dialog, component) {
    const wishlistImage = dialog.querySelector('.js-dialog-wishlist-img-container img');
    if (wishlistImage) {
        wishlistImage.src = component.dataset.wishlistProductImg ?? '';
    }
}
function add(component, endpoint) {
    const ean = component.dataset.wishlistProductEan ?? '';
    if (PENDING_EANS.has(ean))
        return;
    const url = component.dataset.wishlistRetrieveSizeOnAdd === 'true' ? changeEanInEndpoint(endpoint) : endpoint;
    PENDING_EANS.add(ean);
    setStateAll(component, 'remove');
    fetch(url, { method: 'POST' })
        .then((response) => {
        if (!response.ok) {
            setStateAll(component, 'add');
            return;
        }
        const tracking = component.dataset.tracking ? JSON.parse(component.dataset.tracking) : null;
        const wishlistDialog = document.getElementById(DIALOG_WISHLIST_ADD_ID);
        if (wishlistDialog) {
            wishlistDialog.dataset.tracking = component.dataset.tracking;
            updateProductImage(wishlistDialog, component);
            Dialogs.show(DIALOG_WISHLIST_ADD_ID);
            if (tracking) {
                analytics.popinWishlist(tracking);
            }
        }
        if (tracking) {
            analytics.productAddedWishlist(tracking);
        }
    })
        .catch(() => {
        setStateAll(component, 'add');
    })
        .finally(() => {
        PENDING_EANS.delete(ean);
    });
}
function remove(component, endpoint) {
    const ean = component.dataset.wishlistProductEan ?? '';
    if (PENDING_EANS.has(ean))
        return;
    const url = component.dataset.wishlistRetrieveSizeOnAdd === 'true' ? changeEanInEndpoint(endpoint) : endpoint;
    PENDING_EANS.add(ean);
    setStateAll(component, 'add');
    fetch(url, { method: 'POST' })
        .then((response) => {
        if (!response.ok) {
            setStateAll(component, 'remove');
            return;
        }
        const tracking = JSON.parse(component.dataset.tracking ?? '{}');
        analytics.productRemovedWishlist(tracking);
    })
        .catch(() => {
        setStateAll(component, 'remove');
    })
        .finally(() => {
        PENDING_EANS.delete(ean);
    });
}
function handleToggle() {
    document.body.addEventListener('click', (event) => {
        const wishlistComponent = event.target.closest('[data-component="wishlist-item"]');
        if (!wishlistComponent)
            return;
        const toggleButton = wishlistComponent.querySelector('button');
        if (!toggleButton)
            return;
        const dialogWishlistDisabled = document.getElementById(DIALOG_WISHLIST_DISABLED_ID);
        if (dialogWishlistDisabled !== null) {
            updateProductImage(dialogWishlistDisabled, wishlistComponent);
            Dialogs.show(DIALOG_WISHLIST_DISABLED_ID);
            setTimeout(() => {
                window.redirect(`${routes.connect}?redirect=${window.location.href}`);
            }, 3000);
            return;
        }
        toggleButton.getAttribute('aria-pressed') === 'true'
            ? remove(wishlistComponent, wishlistComponent.dataset.wishlistRemoveEndpoint ?? '')
            : add(wishlistComponent, wishlistComponent.dataset.wishlistAddEndpoint ?? '');
    });
}
export function updateWishlist(ean) {
    if (!ean) {
        toggleWishlistItem();
        return;
    }
    const mainWishlist = document.querySelector('.js-product-content [data-wishlist-product-ean]');
    if (mainWishlist) {
        mainWishlist.dataset.wishlistProductEan = ean;
    }
    const wishlistComponents = document.querySelectorAll(`[data-wishlist-product-ean="${ean}"]`);
    if (wishlistComponents.length > 0) {
        setInitialState(wishlistComponents);
    }
}
export default function toggleWishlistItem() {
    const wishlistComponents = document.querySelectorAll('*[data-component="wishlist-item"]');
    if (wishlistComponents.length === 0)
        return;
    if (!isToggleInitialized) {
        isToggleInitialized = true;
        const dialogWishlistDisabled = document.getElementById(DIALOG_WISHLIST_DISABLED_ID);
        if (dialogWishlistDisabled !== null) {
            Dialogs.create(DIALOG_WISHLIST_DISABLED_ID);
        }
        else {
            Dialogs.create(DIALOG_WISHLIST_ADD_ID, {
                onClose: (instance) => {
                    const img = document.getElementById(DIALOG_WISHLIST_ADD_ID)?.querySelector('.js-dialog-wishlist-img-container img');
                    if (img)
                        img.src = '';
                    const trackingData = instance.dialog.dataset.tracking;
                    if (!trackingData)
                        return;
                    analytics.popinWishlistClosed(JSON.parse(trackingData));
                },
            });
        }
        handleToggle();
    }
    setInitialState(wishlistComponents);
}
